var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmingWatersportsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.28167 63.82734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.9592,
    cy: 26.27812,
    r: 9.84231,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28167,51.97766v-4.1661a10.31717,10.31717,0,0,1-13.53331,0,5.3277,5.3277,0,0,0-6.9717,0,10.31716,10.31716,0,0,1-13.5333,0,5.3277,5.3277,0,0,0-6.9717,0,10.31717,10.31717,0,0,1-13.53331,0,5.3277,5.3277,0,0,0-6.9717,0A10.21,10.21,0,0,1,0,50.34051v4.1661a10.21,10.21,0,0,0,6.76665-2.529,5.3277,5.3277,0,0,1,6.9717,0,10.31717,10.31717,0,0,0,13.53331,0,5.3277,5.3277,0,0,1,6.9717,0,10.31716,10.31716,0,0,0,13.5333,0,5.3277,5.3277,0,0,1,6.9717,0,10.21,10.21,0,0,0,6.76666,2.529A10.34414,10.34414,0,0,0,68.28167,51.97766Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28167,61.29839v-4.1661a10.31717,10.31717,0,0,1-13.53331,0,5.3277,5.3277,0,0,0-6.9717,0,10.31716,10.31716,0,0,1-13.5333,0,5.3277,5.3277,0,0,0-6.9717,0,10.31717,10.31717,0,0,1-13.53331,0,5.3277,5.3277,0,0,0-6.9717,0A10.21,10.21,0,0,1,0,59.66124v4.1661a10.21,10.21,0,0,0,6.76665-2.529,5.3277,5.3277,0,0,1,6.9717,0,10.31717,10.31717,0,0,0,13.53331,0,5.3277,5.3277,0,0,1,6.9717,0,10.31716,10.31716,0,0,0,13.5333,0,5.3277,5.3277,0,0,1,6.9717,0,10.21,10.21,0,0,0,6.76666,2.529A10.34414,10.34414,0,0,0,68.28167,61.29839Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7205,20.95a1.49406,1.49406,0,0,1,.205.34175l9.70571,9.70571L14.01175,42.617a9.08521,9.08521,0,0,1,2.80235,1.70875,5.55908,5.55908,0,0,0,3.62256,1.367,5.42771,5.42771,0,0,0,3.62255-1.367,9.95509,9.95509,0,0,1,13.2599,0,5.55908,5.55908,0,0,0,3.62255,1.367,5.3016,5.3016,0,0,0,3.62255-1.367,9.90879,9.90879,0,0,1,6.62995-2.529c.20506,0,.34175.06835.47845.06835L34.85851,24.9143h0l-5.94645-5.94645L50.85241,10.4241A5.38817,5.38817,0,1,0,46.95646.37665L17.29255,11.9278a5.37164,5.37164,0,0,0-3.07575,6.9717A5.70973,5.70973,0,0,0,15.7205,20.95Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingWatersportsWhite);
export default __webpack_public_path__ + "static/media/SwimmingWatersports_White.a0b3e589878d3118a573c09987907922.svg";
export { ForwardRef as ReactComponent };